<!-- src/components/RoleGate.vue -->
<template>
  <div
    :class="{ 'role-disabled': !hasPermission && showWhenDenied }"
    :style="{ pointerEvents: !hasPermission && showWhenDenied ? 'none' : 'auto', opacity: !hasPermission && showWhenDenied ? 0.5 : 1 }"
  >
    <slot v-if="hasPermission || showWhenDenied" :disabled="!hasPermission" />
  </div>
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'
import { computed } from 'vue'

const props = defineProps({
  minLevel: { type: String, default: null },
  showWhenDenied: { type: Boolean, default: true }
})

const auth = useAuthStore()

const hasPermission = computed(() => {
  if (!props.minLevel) return true 
  return auth.hasMinimumLevel(props.minLevel)
})
</script>

<style scoped>
.role-disabled {
  cursor: not-allowed;
  user-select: none;
}
</style>
